import { Facebook, Instagram } from "lucide-react";
import { BUSINESS } from "@/lib/brand";

const TikTok = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M14 3v11.5a3.5 3.5 0 1 1-3.5-3.5" />
    <path d="M14 3c.4 2.6 2.2 4.4 5 4.6" />
  </svg>
);

const ICONS = { facebook: Facebook, instagram: Instagram, tiktok: TikTok };

export const SocialLinks = ({ className = "", prefix = "social" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    {BUSINESS.social.map(({ id, label, href }) => {
      const Icon = ICONS[id];
      return (
        <a key={id} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} data-testid={`${prefix}-${id}-link`}
          className="w-9 h-9 rounded-full border border-current/30 flex items-center justify-center opacity-80 hover:opacity-100 hover:text-[#D5B98C] transition-[opacity,color]">
          <Icon className="w-4 h-4" strokeWidth={1.5} />
        </a>
      );
    })}
  </div>
);
